import { takeEvery, select, put } from 'redux-saga/effects';
import { addStatusToImportStatuses, setImportStatuses, setImportHistoryRefresh } from 'store/actions';
import { importModuleStateSelector } from 'store/selectors';
import { Constants } from 'utilities/constants';

const importTypes = [
  Constants.ImportType.PROPERTIES,
  Constants.ImportType.OPPORTUNITIES,
  Constants.ImportType.TITLES,
]

export function* addStatusToImportStatusesSaga() {
  yield takeEvery(addStatusToImportStatuses, function* ({ payload }) {
    const statusDto = payload;
    if (!statusDto.importType || !importTypes.includes(statusDto.importType)) {
      console.log('no matching importType found in importStatusUpdate dto');
      return;
    }
    const module = statusDto.importType === Constants.ImportType.PROPERTIES ? Constants.Module.EXPLORE : Constants.Module.UNDERWRITE;
    const importModuleState = yield select(importModuleStateSelector, module);
    const previousImportStatuses = importModuleState.importStatuses;

    // TITLES STATUS
    if (statusDto.importType === Constants.ImportType.TITLES) {
      yield put(setImportStatuses({
        module,
        importStatuses: {
          ...previousImportStatuses,
          [statusDto.importId]: {
            ...statusDto,
            importedOn: statusDto.importedOn
          }
        }
      }));
      return;
    }

    // PROPERTIES/OPPORTUNITIES STATUS
    // FIRST UPDATE
    if (!previousImportStatuses.hasOwnProperty(statusDto.importId)) {
      var importStatuses = {};
      importStatuses[statusDto.importId] = {
        importId: statusDto.importId,
        importDbId: statusDto.importDbId,
        importSource: statusDto.importSource,
        channel: statusDto.channel,
        importName: statusDto.importName,
        importCount: statusDto.importCount,
        importedBy: statusDto.importedBy,
        importedOn: statusDto.importedOn,        // convert utc to local datetime

        progressMessages: [],
        warningMessages: [],
        errorMessages: []
      };
      if (statusDto.importType === Constants.ImportType.OPPORTUNITIES) { // Add fields only used by opportunities
        importStatuses[statusDto.importId].importSource = statusDto.importSource;
        importStatuses[statusDto.importId].channel = statusDto.channel;
      }
      importStatuses[statusDto.importId].progressMessages.push(statusDto.progressMessage);
      yield put(setImportStatuses({ 
        module,
        importStatuses: {
          ...previousImportStatuses,
          ...importStatuses 
        }
      }));
    } else { // SUBSEQUENT UPDATES
      const newImportStatusObj = {...previousImportStatuses[statusDto.importId]};
      if (statusDto.progressMessage !== null) {
        newImportStatusObj.progressMessages = [...newImportStatusObj.progressMessages, statusDto.progressMessage];
      }
      if (statusDto.warningMessage !== null) {
        newImportStatusObj.warningMessages = [...newImportStatusObj.warningMessages, statusDto.warningMessage];
      }
      if (statusDto.errorMessage !== null) {
        newImportStatusObj.errorMessages = [...newImportStatusObj.errorMessages, statusDto.errorMessage];
      }
      if (statusDto.importCompletedOn !== null) {
        newImportStatusObj.importCompletedOn = statusDto.importCompletedOn;       // convert utc to local datetime
        newImportStatusObj.importDbId = statusDto.importDbId;
      }

      if (statusDto.importCompletedOn !== null || statusDto.importFailedOn !== null) {
        const importRefresh = (importModuleState.importHistoryRefresh ?? 0) + 1;
        yield put(setImportHistoryRefresh({module, value: importRefresh}));
      }
      newImportStatusObj.log = statusDto.log;
      newImportStatusObj.isFaulted = statusDto.isFaulted;

      yield put(setImportStatuses({ 
        module,
        importStatuses: {
          ...previousImportStatuses,
          [statusDto.importId]: newImportStatusObj
        }
      }));
    }
  });
}